import type { ApproverDecision, RequisitionAssignedFlow } from '@core/requisitions-types';

type AssignedFlowEntityId = `requisition:${number}`;
export const getAssignedFlowEntityId = ({ requisitionId }: { requisitionId: number }) =>
  <AssignedFlowEntityId>`requisition:${requisitionId}`;

export type AssignedFlowEntity = {
  id: AssignedFlowEntityId;
  approvalFlow: RequisitionAssignedFlow | null;
};

export type AssignedFlowResponse = {
  approvalFlow: RequisitionAssignedFlow | null;
};

export type ApproverDecisionResponse = Partial<ApproverDecision> & { id: number };

export type UpdateApproversStepsPayload = Array<{ id: number; approverIds?: number[] }>;

export type UpdateApproversBody = {
  approvalFlow: {
    steps: UpdateApproversStepsPayload;
  };
};
